import React from 'react';
import { Provider } from 'react-redux';
import ReactNotifications from 'react-notifications-component';

import 'pretty-checkbox';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-notifications-component/dist/theme.css';
import 'react-datepicker/dist/react-datepicker.min.css';
import './App.css';

import store, { history } from './redux/store';
import Routes from './routes';

function App () {
  return (
    <Provider store={store}>
      <Routes history={history} />
      <ReactNotifications />
    </Provider>
  );
}

export default App;
